import { render } from "./HFO_MP_008.vue?vue&type=template&id=5a54c40e"
import script from "./HFO_MP_008.vue?vue&type=script&lang=js"
export * from "./HFO_MP_008.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__